<template>
  <page-view title="自定义群组">
    <!-- action -->
    <template slot="action">
      <a-button type="primary" icon="plus-circle" @click="onAddGroup">创建群组</a-button>
    </template>
    <a-card :bordered="false">
      <s-table ref="table"
               :columns="columns"
               :rowKey="record => record.id"
               :data="loadData"
               size="middle">
        <span slot="action" slot-scope="record">
                <a @click="onEdit(record)">编辑</a>
                <a-divider type="vertical"/>
                <a-popconfirm title="是否确认删除?" @confirm="onDelete(record)">
                    <a href="#">删除</a>
                </a-popconfirm>
            </span>
      </s-table>
    </a-card>

    <LocalGroupAdd ref="localGroupAdd" @success="onRefresh"/>
    <LocalGroupEdit ref="localGroupEdit" @success="onRefresh"/>

  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import qs from 'qs'
import LocalGroupAdd from './LocalGroupAdd'
import LocalGroupEdit from './LocalGroupEdit'

const columns = [
  {
    title: '序号',
    dataIndex: 'seqNo'
  },
  {
    title: '群组名称',
    dataIndex: 'groupName'
  },
  {
    title: '群组成员',
    dataIndex: 'extras.users'
  },
  {
    title: '操作',
    width: '150px',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'LocalGroupIndex',
  components: {
    PageView,
    STable,
    LocalGroupAdd,
    LocalGroupEdit
  },
  mounted () {
  },
  data () {
    return {
      columns,
      queryForm: {
        name: ''
      },
      queryParams: {},
      loadData: parameter => {
        return this.$http.get('/api/1/workflow/local_group/query_local_group.json', {
          params: Object.assign(parameter, this.queryParams),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          return res
        })
      }
    }
  },
  methods: {
    onSearch () {
      this.queryParams = { ...this.queryForm }
      this.$refs.table.refresh()
    },
    onRefresh () {
      this.$refs.table.refresh()
    },
    onAddGroup () {
      this.$refs.localGroupAdd.preGroupAdd()
    },
    onEdit (record) {
      this.$refs.localGroupEdit.preGroupEdit(record.id)
    },
    onDelete (record) {
      let that = this
      this.$http.get('/api/1/workflow/local_group/delete_local_group.json?id=' + record.id).then(function () {
        that.$message.success('删除群组成功')
        that.$refs.table.refresh()
      })
    }
  }
}
</script>

<style scoped>

</style>
